export default __webpack_public_path__ + "static/media/attach-file.4b045dba.svg";